import React from 'react'
import { twMerge } from 'tailwind-merge'

type DividerProps = React.ComponentPropsWithoutRef<'div'>

const Divider = ({ className, ...props }: DividerProps) => {
    return (
        <div
            {...props}
            className={twMerge(['my-6 h-px w-full bg-gray-200', className])}
            data-testid="divider-line"
        />
    )
}

export default Divider
